import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from '@/components/ui/Toast';
import { useToast } from '@/components/ui/useToast';
import { useI18n } from '@/i18n';

export function Toaster() {
  const { t } = useI18n();
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{typeof title === 'string' ? t(title) : title}</ToastTitle>}
              {description && <ToastDescription>{typeof description === 'string' ? t(description) : description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
